import initialState from "../initialState";
import { availableAssetIds } from "../../constants";

import {
  InitialState,
  ASSETS_DATA_FETCHED,
  MARKET_DATA_FETCHED,
  LATEST_PRICES_FETCHED,
  COMPANY_DATA_FETCHED,
  COIN_INFO_SELECTED,
  LATEST_TOKEN_PRICE_FETCHED,
  COIN_INFO_REMOVED,
  MarketActionsT,
} from "../types";

const marketReducer = (
  state = initialState.marketState,
  action: MarketActionsT
): InitialState["marketState"] => {
  switch (action.type) {
    case ASSETS_DATA_FETCHED:
      return {
        ...state,
        ownAssets: action.payload.filter((a) =>
          availableAssetIds.includes(a.assetId)
        ),
      };
    case MARKET_DATA_FETCHED:
      return {
        ...state,
        markets: action.payload.filter(
          (m, i, a) =>
            a.findIndex((t) => t.amountAsset === m.amountAsset) === i &&
            availableAssetIds.includes(m.amountAsset)
        ),
      };
    case LATEST_PRICES_FETCHED: {
      const marketsWithPrice = state.markets?.map((market, index) => {
        return { price: action.payload[index].lastPrice / 10 ** 14, ...market };
      });

      const MarketsoObject = Object.assign(
        {},
        ...marketsWithPrice.map((market) => ({
          [market.amountAsset]: { ...market },
        }))
      );
      return {
        ...state,
        markets: marketsWithPrice,
        ownAssets: state.ownAssets?.map((asset) => {
          return {
            ...asset,
            price: MarketsoObject[asset.assetId]?.price,
          };
        }),
      };
    }
    case COMPANY_DATA_FETCHED: {
      const marketsWithCompanyData = state.markets?.map((market) => {
        const match = action.payload.find(
          (company) => company.assetId === market.amountAsset
        );

        if (match) {
          return {
            tokenName: match.tokenName,
            tokenShortName: match.tokenShortName,
            companyName: match.name,
            tokenUrl: match.tokenImage ? match.tokenImage.url : null,
            ...market,
          };
        }
        return { ...market };
      });

      const ownAssetswithCompanyData = state.ownAssets?.map((asset) => {
        const match = action.payload.find(
          (company) => company.assetId === asset.assetId
        );
        if (match) {
          return {
            tokenName: match.tokenName,
            tokenUrl: match.tokenImage ? match.tokenImage.url : null,
            ...asset,
          };
        }
        return { ...asset };
      });

      return {
        ...state,
        markets: marketsWithCompanyData,
        ownAssets: ownAssetswithCompanyData,
      };
    }
    case COIN_INFO_SELECTED: {
      let ownedValue: number;
      const ar = state.ownAssets.map((asset) => asset.assetId);
      if (ar.includes(action.payload.assetId)) {
        ownedValue =
          state.ownAssets.filter(
            (asset) => asset.assetId === action.payload.assetId
          )[0]?.balance / 100;
      } else {
        ownedValue = 0;
      }

      return {
        ...state,
        coinInfo: {
          name: action.payload.name,
          price: action.payload.price,
          assetId: action.payload.assetId,
          company: action.payload.company,
          ownedValue,
        },
      };
    }

    case LATEST_TOKEN_PRICE_FETCHED: {
      const p = { price: action.payload.price };
      return {
        ...state,
        coinInfo: { ...state.coinInfo, ...p },
      };
    }

    case COIN_INFO_REMOVED:
      return {
        ...state,
        coinInfo: null,
      };
    default:
      return state;
  }
};

export default marketReducer;
